import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

export const StyledCertificateCard = styled.button<{ disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    border-radius: 1.43rem;
    width: 100%;
    background-color: white;
    list-style: none;
    position: relative;
    text-decoration: none;
    border: 1px solid ${theme.palette.lightGray};
    text-align: left;
    transition: box-shadow 0.2s, transform 0.2s;

    ${theme.mediaQueries.tabletMax} {
        margin-block: 2rem;
    }
    ${theme.mediaQueries.mobileMax} {
        margin-block: 1rem !important;
    }

    ${p => p.disabled ? `
        cursor: not-allowed;
    ` : `
        &:hover {
            box-shadow: 0.2rem 0.2rem 0.86rem 0px rgba(0, 0, 0, 0.09);
            transform: scale(0.97);
        }
    `}
`;

export const StyledCertificateCardOverlay = styled.div<{ generating?: boolean }>`
    position: relative;
    background: ${p => p.generating ? theme.palette.atosLightestBlue : theme.palette.atosLightBlue};
    border-top-left-radius: 1.43rem;
    border-top-right-radius: 1.43rem;
`;

export const StyledCertificateIconContainer = styled.div<{ generating?: boolean; error?: boolean; }>`
    padding-top: 1rem;
    padding-bottom: 0.5rem;
    height: 16rem;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    transition: height 0.4s, opacity 0.4s;

    ${p => p.error ? `
        height: 9rem;
    ` : ''}
    ${p => p.generating ? `
        opacity: 0.2;
        height: 9rem;
    ` : ''}
`;

export const StyledCertificateIconContainerInner = styled.div<{ generating?: boolean; error?: boolean; }>`
    display: flex;
    height: 10rem;
    transition: height 0.4s;
    ${p => p.generating || p.error ? `
        height: 8.5rem;
    ` : ''}
`;

export const StyledLoadingSpinnerContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const StyledCertificateCardText = styled.div<{ showGeneratorStatusText?: boolean }>`
    display: flex;
    flex-direction: column;
    padding-block: 2rem;
    padding-inline: 2rem;
    padding-bottom: 1.5rem;
    height: 15.5rem;
    transition: height 0.4s;
    ${p => p.showGeneratorStatusText ? 'height: 22.5rem;' : ''}
`;

export const StyledDownloadButtonContainer = styled.div<{ disabled?: boolean; pushDown?: boolean }>`
    margin: 0px auto;
    margin-top: auto;
    ${p => p.disabled ? `
        opacity: 0.25;
    ` : ''}
    ${p => p.pushDown ? `
        margin-top: 1rem;
    ` : ''}
`;

type OutputProps = { 
    error?: boolean;
};

export const StyledOutput = styled.div<OutputProps>`
    margin-top: auto;
    padding: 0.7rem 1.3rem;
    border-radius: ${theme.borderRadius.small};
    display: flex;
    align-items: center;

    ${p => p.error 
        ? `background: ${theme.palette.lighterPink};`
        : 'animation: pulse 2.2s infinite;'}

    @media print {
        display: none;
    }

    @keyframes pulse {
        0% {
            background-color: ${theme.palette.lightBeige};
        }
        50% {
            background-color: #e8e8e8;
        }
        100% {
            background-color: ${theme.palette.lightBeige};
        }
    }
`;
